/* eslint-disable @typescript-eslint/no-namespace */
export namespace RecipeBootstrap {
  export const predicate = 'oobe-bootstrap-controller-recipe'
  export const version = 'v2_0_0'
  export const versionPostcard = 'v3_0_0'
  export const versionCDMOnlyPostcard = 'v4_0_0'
}

export namespace RecipePreFetch {
  export const predicate = 'od-pre-fetch-recipe'
  export const version = 'v2_0_0'
}

export namespace RecipeCDM {
  export const predicate = 'od-pre-fetch-cdm-recipe'
  export const version = 'v1_0_0'
}

export namespace RecipeLEDM {
  export const predicate = 'od-pre-fetch-ledm-recipe'
  export const version = 'v1_0_0'
}

export namespace RecipeProductNumber {
  export const predicate = 'product-number-recipe'
  export const version = 'v1_0_0'
}
